module.exports = __webpack_public_path__ + "static/img/main-visual.8806bad.png";